import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  class: "p-d-flex p-justify-end p-ai-center",
  style: {"width":"100%"}
}

import { defineAsyncComponent } from "vue";
import { useRoles } from "@/hooks/role/useRoles";
import CreateRole from "./CreateRole.vue";
import { useRemoveRole } from "./useRemoveRole";


export default /*#__PURE__*/_defineComponent({
  __name: 'RoleTab',
  setup(__props) {

const RoleDefaults = defineAsyncComponent(() => import("./RoleDefaults.vue"));
const UpdateRole = defineAsyncComponent(() => import("./UpdateRole.vue"));

const { loading, roles } = useRoles();

const { handleRemove, removeLoading } = useRemoveRole();

return (_ctx: any,_cache: any) => {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CreateRole),
    (_unref(loading))
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          class: "p-mt-2",
          mode: "indeterminate",
          style: {"height":"0.5em"}
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Accordion, {
      lazy: "",
      activeIndex: 0,
      class: "p-mt-2"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(roles), (role, index) => {
          return (_openBlock(), _createBlock(_component_AccordionTab, {
            key: `role-accordion-${index}-${role.id}`,
            header: role.name
          }, _createSlots({
            default: _withCtx(() => [
              (role.activityId)
                ? (_openBlock(), _createBlock(_unref(UpdateRole), {
                    key: 0,
                    role: role
                  }, null, 8, ["role"]))
                : (_openBlock(), _createBlock(_unref(RoleDefaults), {
                    key: 1,
                    access: role.access
                  }, null, 8, ["access"]))
            ]),
            _: 2
          }, [
            (role.activityId)
              ? {
                  name: "header",
                  fn: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_Button, {
                        icon: "pi pi-trash",
                        class: "p-button-sm p-button-danger p-button-text",
                        disabled: _unref(removeLoading),
                        onClick: ($event: any) => (_unref(handleRemove)($event, role.id))
                      }, null, 8, ["disabled", "onClick"])
                    ])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["header"]))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}
}

})